import { FormInputUrl } from '@systemeio/ui'
import { useApplePayActions } from 'modules/profile/payment-gateways/integrations/stripe/hooks'
import {
  ApplePayActivateDomainErrors,
  ApplePayActivateDomainModalForm,
} from 'modules/profile/payment-gateways/integrations/stripe/types'
import { useState } from 'react'
import ButtonLikeLink from 'shared/components/button-like-link'
import CreateModal from 'shared/components/create-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { ApplePayIcon } from '@systemeio/ui/icons'

const defaultValues: ApplePayActivateDomainModalForm = { hostName: '', file: null }
const defaultErrors: ApplePayActivateDomainErrors = {
  hostName: [],
}

export interface ApplePayActivateDomainModalProps {
  afterLeave: () => void
}

const ApplePayActivateDomainModal = ({ afterLeave }: ApplePayActivateDomainModalProps) => {
  const { t } = useLocoTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const [errors, setErrors] = useState(defaultErrors)

  const { connectDomain } = useApplePayActions({
    badRequestHandler: ({ errors }) => {
      if (errors.fields) {
        setErrors(prev => ({ ...prev, ...errors.fields }))
      }
    },
  })

  const handleActivateDomain = async ({ hostName }: ApplePayActivateDomainModalForm) => {
    await connectDomain({ hostName })
  }

  const onClose = () => setIsOpen(false)

  return (
    <>
      <ButtonLikeLink onClick={() => setIsOpen(true)}>
        <ApplePayIcon height={20} />
      </ButtonLikeLink>
      <CreateModal
        defaultValues={defaultValues}
        opened={isOpen}
        modalDescription={t(
          'dashboard.settings.payment_gateways.activate_apple_pay_domain.description',
        )}
        caption={t('global.domain')}
        afterLeave={() => {
          setErrors(defaultErrors)
          afterLeave()
        }}
        onClose={onClose}
        onCreate={handleActivateDomain}
        creatable={[
          {
            field: 'hostName',
            onRender: (value, onChange) => (
              <FormInputUrl
                addonBefore="https://"
                key="hostname"
                error={errors.hostName?.join('')}
                type="url"
                placeholder="www.yourdomain.com"
                label={t('global.domain')}
                value={value}
                onChange={onChange}
              />
            ),
          },
        ]}
        requiredFields={['hostName']}
      />
    </>
  )
}

export default ApplePayActivateDomainModal
